import { FEATURE_FLAGS } from '../../../../featureFlags';
import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import AgentHome from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/agents'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          redirect: to => {
            return { name: 'agent_list', params: to.params };
          },
        },
        {
          path: 'list',
          name: 'agent_list',
          component: AgentHome,
          meta: {
            featureFlag: FEATURE_FLAGS.AGENT_MANAGEMENT,
            // Supervisor de time entra aqui em modo reduzido: a API já devolve
            // só os agentes dos times que ele supervisiona, e a tela (Index.vue)
            // esconde convidar/excluir — editar fica limitado ao nome.
            permissions: ['administrator', 'team_supervisor'],
          },
        },
      ],
    },
  ],
};
